import styles from "./index.module.scss";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import AddIcon from "@mui/icons-material/Add";
import Box from "@mui/material/Box";
import globalStyles from "../../shared/_stylesParams.module.scss";
import { RootState } from "../../redux/store";
import { useSelector } from "react-redux";
import { useState } from "react";
import RemoveIcon from "@mui/icons-material/Remove";

interface IStyledAccordion {
  configs: { question: string; answer: JSX.Element }[];
}

const accordionBorderCSS = `3px solid ${globalStyles.secondary_90}`;

const StyledAccordion = ({ configs }: IStyledAccordion) => {
  const [expandedAcc, setExpandedAcc] = useState<boolean | string>(false);
  const screenType = useSelector((state: RootState) => state.ui.screenType);

  const handleChange =
    (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
      setExpandedAcc(newExpanded ? panel : false);
    };

  return (
    <div style={{ background: "white" }}>
      <div
        style={{
          borderTop: `${screenType === "PC" ? "3.5px" : "3px"} solid ${
            globalStyles.secondary_90
          }`,
        }}
      ></div>
      {configs.map((config, index) => (
        <Accordion
          key={config.question}
          expanded={expandedAcc === config.question}
          onChange={handleChange(config.question)}
          className={styles.accordion}
          sx={{
            borderBottom: accordionBorderCSS,
            boxShadow: "unset",
            "&.Mui-expanded": {
              borderTop: index == 0 ? "" : accordionBorderCSS,
            },
            "&.MuiAccordion-root": {
              position: "unset",
            },
            "&.MuiAccordion-root:before": {
              backgroundColor: "white",
            },
          }}
        >
          <AccordionSummary
            expandIcon={
              expandedAcc === config.question ? (
                <RemoveIcon sx={{ color: globalStyles.secondary_90 }} />
              ) : (
                <AddIcon sx={{ color: globalStyles.secondary_90 }} />
              )
            }
            aria-controls='panel1a-content'
            id='panel1a-header'
          >
            <Box className={`bold_weight ${styles.title}`}>
              {config.question}
            </Box>
          </AccordionSummary>
          <AccordionDetails className='title_medium regular_weight'>
            {config.answer}
          </AccordionDetails>
        </Accordion>
      ))}
    </div>
  );
};

export default StyledAccordion;
